import React from "react";
import { Routes, Route } from "react-router-dom";
import Client from "./client";
import NewPreventivo from "../../../Screen/User/newPreventivo";
export const ClientRoutes = () => {

    return (
        <Routes>
            <Route index element={<Client />} />
            <Route path="/configurations" element={<NewPreventivo />} />
        </Routes>
    );
}